import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PlaceLoaderComponent } from "./place_loader.component";
import { PaginatorModule } from "../../elementi-strutturali/paginator/paginator.module";
import { InputSearchModule } from "../../elementi-strutturali/input-search/input-search.module";
import { MapModule } from "../../elementi-strutturali/map/map.module";


@NgModule({
  imports: [CommonModule, PaginatorModule, InputSearchModule, MapModule],
  declarations: [PlaceLoaderComponent],
  exports: [PlaceLoaderComponent],

})
export class PlaceLoaderModule { 
  static component = PlaceLoaderComponent
}